import { PurchasedPackage, AvailablePackage, PackageModuleInfo } from "./packages.interfaces";

export const MOCK_PURCHASED_PACKAGES: PurchasedPackage[] = [
  {
    id: "1",
    name: "Pacote 1",
    modality: "Online",
    level: "Intermediário",
    duration: "6 meses",
    modulesCount: 8,
    discount: 0,
    image: "https://images.unsplash.com/photo-1503220317375-aaad61436b1b?auto=format&fit=crop&w=800&q=80",
    isValidNow: true,
    studentProgress: {
      progress: 75,
      status: "progress",
      startDate: "Jan 2023",
      endDate: "Jul 2023"
    }
  },
  {
    id: "2",
    name: "Pacote 2",
    modality: "Presencial",
    level: "Básico",
    duration: "3 meses",
    modulesCount: 5,
    discount: 0,
    image: "https://images.unsplash.com/photo-1609607847926-da4702f01fef?auto=format&fit=crop&w=800&q=80",
    isValidNow: true,
    studentProgress: {
      progress: 100,
      status: "concluido",
      startDate: "Out 2022",
      endDate: "Jan 2023",
      isCompleted: true
    }
  },
  {
    id: "3",
    name: "Pacote 3",
    modality: "Online",
    level: "Avançado",
    duration: "8 meses",
    modulesCount: 12,
    discount: 0,
    image: "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?auto=format&fit=crop&w=800&q=80",
    isValidNow: false,
    studentProgress: {
      progress: 0,
      status: "neon",
      startDate: "Mar 2023"
    }
  },
  {
    id: "4",
    name: "Pacote 4",
    modality: "Online",
    level: "Intermediário",
    duration: "6 meses",
    modulesCount: 8,
    discount: 0,
    image: "https://images.unsplash.com/photo-1465146344425-f00d5f5c8f07?auto=format&fit=crop&w=800&q=80",
    isValidNow: true,
    studentProgress: {
      progress: 50,
      status: "progress",
      startDate: "Fev 2023"
    }
  },
  {
    id: "5",
    name: "Pacote 5",
    modality: "Presencial",
    level: "Básico",
    duration: "4 meses",
    modulesCount: 6,
    discount: 0,
    image: "https://images.unsplash.com/photo-1506744038136-46273834b3fb?auto=format&fit=crop&w=800&q=80",
    isValidNow: true,
    studentProgress: {
      progress: 25,
      status: "progress",
      startDate: "Abr 2023"
    }
  },
  {
    id: "6",
    name: "Pacote 6",
    modality: "Online",
    level: "Avançado",
    duration: "10 meses",
    modulesCount: 15,
    discount: 0,
    image: "https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=800&q=80",
    isValidNow: true,
    studentProgress: {
      progress: 90,
      status: "progress",
      startDate: "Jan 2023"
    }
  },
  {
    id: "7",
    name: "Pacote 7",
    modality: "Online",
    level: "Intermediário",
    duration: "6 meses",
    modulesCount: 8,
    discount: 0,
    image: "https://images.unsplash.com/photo-1498855926480-d98e83099315?auto=format&fit=crop&w=800&q=80",
    isValidNow: true,
    studentProgress: {
      progress: 10,
      status: "neon",
      startDate: "Mai 2023"
    }
  }
];

export const MOCK_AVAILABLE_PACKAGES: AvailablePackage[] = [
  {
    id: "1",
    name: "Pacote Básico",
    modality: "Online",
    level: "Iniciante",
    duration: "3 meses",
    modulesCount: 2,
    discount: 0,
    image: "https://images.unsplash.com/photo-1447752875215-b2761acb3c5d?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "2",
    name: "Pacote Premium",
    modality: "Presencial",
    level: "Avançado",
    duration: "6 meses",
    modulesCount: 10,
    discount: 15,
    image: "https://images.unsplash.com/photo-1447752875215-b2761acb3c5d?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "3",
    name: "Pacote Premium",
    modality: "Online",
    level: "Intermediário",
    duration: "4 meses",
    modulesCount: 8,
    discount: 0,
    image: "https://images.unsplash.com/photo-1519681393784-d120267933ba?auto=format&fit=crop&w=800&q=80",
  },
  {
    id: "4",
    name: "Pacote Avançado",
    modality: "Online",
    level: "Avançado",
    duration: "8 meses",
    modulesCount: 12,
    discount: 0,
    image: "https://images.unsplash.com/photo-1501785888041-af3ef285b470?auto=format&fit=crop&w=800&q=80",
  }
];

// Módulos simulados para cada pacote
const MOCK_PACKAGE_MODULES: Record<string, PackageModuleInfo[]> = {
  // Pacote 1
  "1": [
    {
      id: "mod-1-1",
      name: "Fundamentos do Inglês",
      description: "Estudo dos fundamentos básicos da língua inglesa",
      order: 1,
      state: "completed"
    },
    {
      id: "mod-1-2",
      name: "Vocabulário Essencial",
      description: "Expansão do vocabulário com palavras do dia a dia",
      order: 2,
      state: "completed"
    },
    {
      id: "mod-1-3",
      name: "Conversação Básica",
      description: "Prática de conversação em situações cotidianas",
      order: 3,
      state: "in-progress"
    },
    {
      id: "mod-1-4",
      name: "Estruturas Gramaticais",
      description: "Estudo de estruturas gramaticais fundamentais",
      order: 4,
      state: "available"
    },
    {
      id: "mod-1-5",
      name: "Compreensão Auditiva",
      description: "Exercícios para melhorar a compreensão auditiva",
      order: 5,
      state: "not_available"
    },
    {
      id: "mod-1-6",
      name: "Expressões Idiomáticas",
      description: "Estudo das principais expressões idiomáticas",
      order: 6,
      state: "not_available"
    },
    {
      id: "mod-1-7",
      name: "Escrita Avançada",
      description: "Técnicas avançadas de escrita em inglês",
      order: 7,
      state: "not_available"
    },
    {
      id: "mod-1-8",
      name: "Preparação para Certificação",
      description: "Preparação final para certificação internacional",
      order: 8,
      state: "not_available"
    }
  ],
  // Pacote 2 (concluído)
  "2": Array.from({ length: 5 }, (_, i) => ({
    id: `mod-2-${i+1}`,
    name: `Módulo ${i+1} do Pacote Básico`,
    description: `Descrição do módulo ${i+1} do pacote básico`,
    order: i+1,
    state: "completed"
  })),
  // Pacote 3 (não iniciado)
  "3": Array.from({ length: 12 }, (_, i) => ({
    id: `mod-3-${i+1}`,
    name: `Módulo ${i+1} do Pacote Avançado`,
    description: `Descrição do módulo ${i+1} do pacote avançado`,
    order: i+1,
    state: "not_available"
  })),
  // Pacote 4 (50% completo)
  "4": Array.from({ length: 8 }, (_, i) => ({
    id: `mod-4-${i+1}`,
    name: `Módulo ${i+1} do Pacote 4`,
    description: `Descrição do módulo ${i+1} do pacote 4`,
    order: i+1,
    state: i < 4 ? "completed" : i === 4 ? "in-progress" : "not_available"
  })),
  // Adicionar outros pacotes conforme necessário...
};

export const getPurchasedPackages = async (): Promise<PurchasedPackage[]> => {
  return MOCK_PURCHASED_PACKAGES;
};

export const getAvailablePackages = async (): Promise<AvailablePackage[]> => {
  return MOCK_AVAILABLE_PACKAGES;
};

// Nova função para obter os módulos de um pacote específico
export const getPackageModules = async (packageId: string): Promise<PackageModuleInfo[]> => {
  // Retorna os módulos para o pacote especificado ou um array vazio
  return MOCK_PACKAGE_MODULES[packageId] || [];
}; 